






































import Vue from 'vue'
import bus from '../model/bus'
import EngramFilter from './EngramFilter.vue'
import TagList from './TagList.vue'

export default Vue.extend({
    name: 'ArkList',
    components: { EngramFilter, TagList },
    data() {
        return {
            bus,
            manager: bus.game.EngramManager,
        }
    },
    created() {},
    computed: {},
    methods: {
        addTag() {
            const name = prompt('Please input the Tag')
            if (name) {
                this.manager.filtered.forEach(item => {
                    if (item.tagxx.indexOf(name) === -1) {
                        item.tagxx.push(name)
                    }
                })
                try {
                    const tag = this.manager.TagManager.make(name)
                    this.manager.TagManager.add(tag)
                } catch (error) {
                    console.error(error)
                }
            }
        },
    },
})
